const CardUtil = {

  deck: function (n = 10, m = 52) {
    let array = new Uint8Array(n);
    window.crypto.getRandomValues(array);
    const randomValues = array.map((e, i) => (e % (m - i)) + 1);
    const fullDeck = Array.from(Array(m), (e, i) => i);
    const typedOut = randomValues.map((v, i) => fullDeck.splice(v, 1)); // avoid reuse
    return Array.from(typedOut) // so we don't have to deal with  it later
  },

  // c[suit][pip]
  // suit = [0..3]
  // pip  = [1..13+] (jokers!)
  cNum2Card: function (num) {
    const suit = Math.floor(num / 13);
    const card = ((num % 13) + 1).toString().padStart(2, '0');
    return `c${suit}${card}`
  },

  rankSuit: function (cCard) {
    // cCard like 'c103'
    const suit = parseInt(cCard.slice(1, 2));
    const suitMap = ["c", "d", "h", "s", "b"]
    const pip = parseInt(cCard.slice(2))
    const pipMap = ["0", "a", "2", "3", "4", "5", "6", "7", "8", "9", "t", "j", "q", "k"]
    return { rank: pipMap[pip], suit: suitMap[suit] }
  },

  cCard2Card: function (cCard) {
    const m = CardUtil.rankSuit(cCard);
    return `${m.rank}${m.suit}`
  }


}

export default CardUtil